export const config = {
  title: 'Space Makers LLC | Transforming Spaces, Clearing Junk Responsibly',
  meta: {
    description:
      'Space Makers LLC offers professional junk removal services in Independence, Oregon. We specialize in residential, apartment, and commercial junk removal with a commitment to eco-friendly practices and community engagement.',
    keywords: [
      'Junk Removal Services',
      'Residential Junk Removal',
      'Apartment Junk Removal',
      'Commercial Junk Removal',
      'Eco-Friendly Junk Removal',
      'Space Makers LLC',
      'Independence Oregon',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: 'Space Makers LLC',
    canonicalUrl: 'https://www.spacemakersllc.com/',
  },
  sections: {
    header: {
      businessName: 'Space Makers LLC',
    },
    sectionB: {
      heroTitle: 'Space Makers LLC',
      heroSubtitle: 'Transforming Spaces, Clearing Junk Responsibly',
      learnAboutText: 'Explore Services',
      phoneNumber: '5416191562',
      phoneLabel: '(541) 619-1562',
      heroBackgroundImage:
        'https://static.wixstatic.com/media/11062b_327964cfd02b4cb38e4010e98f30fd42~mv2.jpeg/v1/fill/w_1448,h_925,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/11062b_327964cfd02b4cb38e4010e98f30fd42~mv2.jpeg',
      cardData: [
        {
          title: 'Residential Junk Removal',
          description:
            'Efficient and responsible junk removal services for homes, ensuring clean and clutter-free living spaces.',
        },
        {
          title: 'Apartment Junk Removal',
          description:
            'Tailored junk removal services for apartment complexes and rental properties.',
        },
        {
          title: 'Commercial Junk Removal',
          description:
            'Professional junk removal solutions for offices, businesses, and other commercial properties.',
        },
      ],
      description:
        'Space Makers LLC provides eco-friendly and efficient junk removal services for residential, apartment, and commercial spaces. Our commitment to quality ensures your space is clean and organized while adhering to responsible disposal practices.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Space Makers LLC offers reliable junk removal services for residential, apartment, and commercial spaces. Our experienced team ensures efficient service and eco-friendly disposal practices.',
      cards: [
        {
          title: 'Residential Junk Removal',
          description:
            'Helping you declutter and maintain clean, comfortable living spaces with hassle-free junk removal services.',
          imageSrc:
            'https://media.istockphoto.com/id/1600121771/photo/dumpster-full-of-garbages-at-residential-garbage-dump-area.jpg?s=612x612&w=0&k=20&c=TOzgik439JYDId6-UEL5s7IxtnKzYqpAsSLFRkGOueY=',
          imageAlt: 'Residential Junk Removal',
        },
        {
          title: 'Apartment Junk Removal',
          description:
            'Efficiently clearing out junk from apartments and shared living spaces, ensuring a fresh start.',
          imageSrc:
            'https://media.istockphoto.com/id/1286996660/photo/hauling-garbage.jpg?s=612x612&w=0&k=20&c=TAPP60NR443yKi9pbGtRkAmAVi3dUBYaYHmAiHluw0w=',
          imageAlt: 'Apartment Junk Removal',
        },
        {
          title: 'Commercial Junk Removal',
          description:
            'Streamlining the junk removal process for businesses, ensuring a clutter-free workspace.',
          imageSrc:
            'https://media.istockphoto.com/id/1406061371/photo/huge-heap-on-metal-big-overloaded-dumpster-waste-container-filled-with-construction-waste.jpg?s=612x612&w=0&k=20&c=Bpb5s0g-4Dz56LdwGSzCB0JorBU4a--W4Vaq8A0P3qA=',
          imageAlt: 'Commercial Junk Removal',
        },
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://static.wixstatic.com/media/729513e38ded41c48e0e2cda14ed1592.jpg/v1/fill/w_721,h_929,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/729513e38ded41c48e0e2cda14ed1592.jpg',
        alt: 'Space Makers LLC Team',
      },
      aboutText: [
        'Space Makers LLC is a family-owned business specializing in junk removal services for residential, apartment, and commercial spaces. Located in Independence, Oregon, we are committed to eco-friendly practices and delivering exceptional customer satisfaction.',
        'Our experienced team works closely with clients to provide transparent pricing, reliable service, and responsible disposal of junk. We take pride in creating clean, organized spaces while contributing to a greener environment.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Space Makers LLC Logo',
      businessName: 'Space Makers LLC',
      contact: {
        phone: '5416191562',
        phoneLabel: '(541) 619-1562',
        email: 'williamerinhawkins@gmail.com',
        website: 'https://www.spacemakersllc.com/',
        address: '894 James St. Independence Oregon 97351, US',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '894 James St. Independence Oregon 97351, US',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.5760110136727!2d-73.21144168467577!3d44.475882479423!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDTCsDI4JzMyLjMiTiA3M8KwMTInMzcuNSJX!5e0!3m2!1sen!2sus!4v1614123456789!5m2!1sen!2sus',
    },
  },
};

export default config;
